export type InfoContainerState = {
  content: InfoContainerContent | null;
  isActive: boolean;
};

export enum InfoContainerContent {
  COOKIE_BANNER = 'cookie_banner',
  ERROR = 'error',
  NOTES = 'notes',
  TRACKLIST = 'tracklist',
}
